import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

export default function NavigateWithQuery(props) {
  const { to, ...rest } = props;
  const [searchParams] = useSearchParams();

  const search = searchParams.toString();

  let computedTo = to;
  if (typeof to === 'string') {
    computedTo = { pathname: to, search };
  } else if (!!to && typeof to === 'object') {
    computedTo = { ...to, search };
  }

  if (typeof to === 'number') return null;

  return <Navigate to={computedTo} {...rest} />;
}
